import Vue from "vue"
import { getRange } from "@/utils/date"

export default Vue.extend({
  methods: {
    programTs (value: string | number): number {
      return typeof value === "number" ? value : Date.parse(value)
    },

    programTime (value: string | number): string {
      const ts = this.programTs(value)

      return Number.isNaN(ts) ? "" : this.$fmt.date(ts, "HH:mm")
    },

    programDay (value: string | number): string {
      const ts = this.programTs(value)

      return Number.isNaN(ts) ? "" : this.$fmt.date(ts, "d MMMM")
    },

    programTimeRange (start: string | number, finish: string | number): string {
      const from = this.programTs(start)
      const to = this.programTs(finish)

      if (Number.isNaN(from) || Number.isNaN(to)) return ""

      return getRange(
        from,
        to,
        this.$i18n.locale,
        this.$store.getters["app/timezone"],
      )
    },
  },
})
